export const wait = (ms: number, abortController?: AbortController): Promise<void> => {
  return new Promise(resolve => {
    const options = abortController?.signal ? { signal: abortController?.signal } : {}
    setTimeout(resolve, ms, options)
  })
}
